import { useEffect, useCallback, useState } from "react";
import { useDispatchApp, useSelectorApp } from "../lib/redux";
import { trackingPurchase } from "../services/tracking";
import { PLAN_TYPE_CREDITS } from "../utils/constants";
import { setIsActivePlan } from "../actions/payments";

const STORAGE_TRACKED_PREFIX = "stripe_purchase_tracked_";

/**
 * Precio publicado en Redux (misma jerarquía que PricingCard).
 */
const resolveCheckoutPlanPrice = (plans, planId, recurrent, typeOfPlans) => {
  if (!planId || !plans?.[planId]) return undefined;
  const byRecurrent = plans[planId][recurrent];
  if (!byRecurrent) return undefined;
  return (
    byRecurrent?.[typeOfPlans]?.price ??
    byRecurrent?.credits?.price ??
    byRecurrent?.price
  );
};

export const useTrialManagement = () => {
  const plans = useSelectorApp((s) => s.payments?.plans);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  const [welcomeModalData, setWelcomeModalData] = useState({
    isTrialActive: false,
    trialEndDate: null,
    planName: "Starter",
  });

  const dispatch = useDispatchApp();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get("status");
    const sessionId = urlParams.get("session_id");
    if (status !== "success" || !sessionId) return;

    const storageKey = `${STORAGE_TRACKED_PREFIX}${sessionId}`;
    if (sessionStorage.getItem(storageKey)) {
      window.history.replaceState({}, document.title, window.location.pathname);
      return;
    }

    const hasPlanCatalog =
      plans && typeof plans === "object" && Object.keys(plans).length > 0;
    if (!hasPlanCatalog) return;

    const plan = urlParams.get("plan") || "starter";
    const typeOfPlans = urlParams.get("typeOfPlans") || PLAN_TYPE_CREDITS;
    const recurrent = urlParams.get("recurrent") || "monthly";

    const price = resolveCheckoutPlanPrice(plans, plan, recurrent, typeOfPlans);

    trackingPurchase(price, plan);

    sessionStorage.setItem(storageKey, "1");

    dispatch(setIsActivePlan(true));

    setWelcomeModalData({
      isTrialActive: true,
      trialEndDate: null,
      planName: plan,
      typeOfPlans,
      recurrent,
    });
    setShowWelcomeModal(true);

    window.history.replaceState({}, document.title, window.location.pathname);
    // eslint-disable-next-line
  }, [plans]);

  const onCloseWelcomeModal = useCallback(() => {
    setShowWelcomeModal(false);
  }, []);

  return {
    showWelcomeModal,
    setShowWelcomeModal,
    welcomeModalData,
    setWelcomeModalData,
    onCloseWelcomeModal,
  };
};
